import { COLOR } from 'vars/index'

export const PartnerBannerOverlay = {
  None: COLOR.TRANSPARENT,
  BANNER_HORIZONTAL_OVERLAY: COLOR.BANNER_HORIZONTAL_OVERLAY,
  BANNER_VERTICAL_OVERLAY: COLOR.BANNER_VERTICAL_OVERLAY,
  SURFACE_OPACITY_DARK_40: COLOR.SURFACE_OPACITY_DARK_40,
  BANNER_PARTIAL_HORIZONTAL_OVERLAY: COLOR.BANNER_PARTIAL_HORIZONTAL_OVERLAY,
} as const
export type PartnerBannerOverlay =
  (typeof PartnerBannerOverlay)[keyof typeof PartnerBannerOverlay]

export const PartnerBannerOverlayDirection = {
  OVERLAY_HORIZONTAL: 'OVERLAY_HORIZONTAL',
  OVERLAY_VERTICAL: 'OVERLAY_VERTICAL',
  OVERLAY_FULL: 'OVERLAY_FULL',
  OVERLAY_HORIZONTAL_VERTICAL: 'OVERLAY_HORIZONTAL_VERTICAL',
  OVERLAY_HORIZONTAL_FULL: 'OVERLAY_HORIZONTAL_FULL',
  OVERLAY_VERTICAL_FULL: 'OVERLAY_VERTICAL_FULL',
  OVERLAY_HORIZONTAL_VERTICAL_FULL: 'OVERLAY_HORIZONTAL_VERTICAL_FULL',
} as const
export type PartnerBannerOverlayDirection =
  (typeof PartnerBannerOverlayDirection)[keyof typeof PartnerBannerOverlayDirection]

export const PartnerBannerJustifyContent = {
  Flex_start: 'flex-start',
  Center: 'center',
  Flex_end: 'flex-end',
  Space_between: 'space-between',
  Space_around: 'space-around',
  Space_evenly: 'space-evenly',
} as const
export type PartnerBannerJustifyContent =
  (typeof PartnerBannerJustifyContent)[keyof typeof PartnerBannerJustifyContent]

export const PartnerBannerAlignItems = {
  Start: 'start',
  Center: 'center',
  End: 'end',
} as const
export type PartnerBannerAlignItems =
  (typeof PartnerBannerAlignItems)[keyof typeof PartnerBannerAlignItems]

export const PartnerBannerCursor = {
  Pointer: 'pointer',
} as const
export type PartnerBannerCursor =
  (typeof PartnerBannerCursor)[keyof typeof PartnerBannerCursor]
